'use client';

import { useEffect } from 'react';
import { pushEvent, CONVERSION_EVENTS } from '@/lib/analytics/core';
import { tiktokEvent } from '@/components/analytics/TikTokPixel';

export default function PricingPageTracker() {
  useEffect(() => {
    pushEvent(CONVERSION_EVENTS.PAGE_VIEW_PRICING);
    tiktokEvent('ViewContent', { content_type: 'product', content_name: 'Pricing Page' });
  }, []);

  return null;
}
